import HCLTreeMxStylesheet from "./HCLTreeMxStylesheet"; // refer to the actual source code

class ESDMxStylesheet extends HCLTreeMxStylesheet {
}

export default ESDMxStylesheet;
